import { NewsletterForm } from "./newsletter/NewsletterForm";
import { NewsletterHeader } from "./newsletter/NewsletterHeader";

export const NewsletterSection = () => {
  return (
    <div className="py-16 px-8 bg-gradient-to-br from-primary/5 to-primary/10 rounded-3xl">
      <div className="max-w-2xl mx-auto text-center space-y-8">
        <NewsletterHeader />
        <NewsletterForm />
        <p className="text-sm text-muted-foreground">
          En vous inscrivant, vous acceptez de recevoir nos emails. Vous pouvez vous désabonner à tout moment.
        </p>
      </div>
    </div>
  );
};